import { ActionTree } from 'vuex';
import { AnnouncementState, RootState } from '../types';
import { state as authState } from '../auth/auth';
import { AxiosInstance, AxiosResponse } from 'axios';
import { handleAllErrors } from '@/utils/errorHandling';

export const actions: ActionTree<AnnouncementState, RootState> = {
	async fetchAnnouncements({ commit }): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;

		try {
			const { data }: AxiosResponse = await axiosInst.get('/announcements');
			commit('SET_ANNOUNCEMENTS', data);
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async createAnnouncement({ commit }, announcement: AnnouncementPayload): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			const { data }: AxiosResponse = await axiosInst.post('/announcements', announcement);
			commit('ADD_ANNOUNCEMENT', { ...data, restaurant_count: announcement.restaurantIds.length });
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async deleteAnnouncement({ commit }, announcementId: number): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;

		try {
			await axiosInst.delete(`/announcements/${announcementId}`);
			commit('DELETE_ANNOUNCEMENT', announcementId);
		}
		catch (error) {
			handleAllErrors(error);
		}
	}
};